const list = () => import('./pages/index')

export default [
  {
    path: '/invoices',
    name: 'import_invoices.index',
    component: list,
    meta: { requiresAuth: true }
  }
]



// WEBPACK FOOTER //
// ./src/features/import_invoices/routes.js